module.exports = __webpack_public_path__ + "img/welcome@2x.495965f6.png";